import React, { useState, useEffect, useCallback } from 'react';
import { Text, View, Pressable, Keyboard } from 'react-native';

import { debounce } from "lodash";
import { store } from '../../store/store';

import { loaderModal } from '../../utils/services/AlertLoaderService';
import { extendLocationData } from '../../utils/services/ExtendedDataUtils';
import { getCurrentLocation } from '../../utils/services/locations/CurrentLocation';
import { updateSearchedLocationHistory } from '../../utils/services/redux/commonRedux';
import { ScreenPushBackData } from '../../utils/services/subject-behaviour/CommonRxjsService';

import { IconView } from '../../utils/widgets/CommonWidget/Icons';
import { AutoColorTypedStringView } from '../../utils/widgets/Common-Widget';
import { CommonSearchLocalityHeader } from '../../utils/widgets/CommonWidget/CommonHeader';

import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { ScreenPushBackCode } from '../../utils/constants/SubjectBehaviousConstant';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import disableScroll from 'disable-scroll';

import CommonBottomSheet from '../../utils/modals/CommonBottomSheet';
import TextInputSearchView from '../../utils/widgets/CommonWidget/CommonTextInputSearchView';

import ModalContent from '../../utils/constants/ModalContentConstant';

import * as OMSAPI from '../../utils/services/api/OMSAPI'

const SearchLocality = (props) => {

    const reduxState = store.getState()
    const isUserLogined = reduxState.isUserLogin
    const [searchWord, setSearchWord] = useState('')
    const [prevSearchResult, updatePrevSearchResult] = useState([])
    const [searchResult, updateSearchResult] = useState([])

    const [blockedLocationModal, setBlockedLocationModal] = useState(false)

    const onChangeText = (_searchWord) => {
        setSearchWord(_searchWord)
        if (_searchWord.length > 3) {
            searchLocationAPI(_searchWord)
        } else updateSearchResult(prevSearchResult);
    }

    const handleSelectedLocationNavigation = (locationData) => {
        props.navigation.pop();
        if (ScreenPushBackCode[global.navigateFrom]) {
            let pushBackCode = ScreenPushBackCode[global.navigateFrom]
            ScreenPushBackData.setData({
                pushBackCode: pushBackCode,
                pushBackData: locationData
            })
        } else {
            props.navigation.pop();
            props.navigation.replace(ScreenRoute.list_pharmacy,
                { selectedLocation: locationData })
        }
    }

    const onLocationSelect = (location) => {
        var list = [location]
        setSearchWord(location['mtxt'])
        updateSearchResult(list);
        if (prevSearchResult.length > 0) {
            if (!prevSearchResult.find((item: any) => item.pid === location.pid))
                updateSearchedLocationHistory(list.concat(prevSearchResult)) // To show the lastest result at top.
        } else updateSearchedLocationHistory(list.concat(prevSearchResult)) // To show the lastest result at top.
        let selectedLocation = extendLocationData(location, { isSavedLocation: false })
        handleSelectedLocationNavigation(selectedLocation)
    }

    const searchLocation = async (searchWord) => {
        let isLoaderHidden = false;
        Keyboard.dismiss();
        setTimeout(() => {
            loaderModal.setLoader(true, 0.6)
        }, 300);
        setTimeout(() => {
            if (isLoaderHidden) {
                loaderModal.setLoader(false)
            }
        }, 1000);
        isUserLogined ? await OMSAPI.doPost('gplaces/search', { 'searchWord': searchWord }).then(
            (response: any) => {
                if ((searchWord.includes(response.searchWord) || response.searchWord.includes(searchWord)) && response.results.length) {
                    updateSearchResult(response.results)
                }
                isLoaderHidden = true;
                loaderModal.setLoader(false)
            }, (err: any) => { console.log("API is failed with error " + err) }
        ) : await OMSAPI.doPostGuest('search_establishment', { 'searchWord': searchWord }).then(  // url: search_establishment
            (response: any) => {
                if ((searchWord.includes(response.searchWord) ||
                    response.searchWord.includes(searchWord)) && response.results) {
                    if (response.results?.length) updateSearchResult(response.results);
                    isLoaderHidden = true;
                    loaderModal.setLoader(false)
                }
            }, (err: any) => { console.log("API is failed with error " + err) }
        )
    }

    const searchLocationAPI = useCallback(debounce((searchWord) => searchLocation(searchWord), AppTheme.searchDebounce), [])

    function textInputView() {
        return <TextInputSearchView
            value={searchWord}
            onChangeText={onChangeText}
            width={AppTheme.appWidth - 71}
            title={'Search for street name / area'} />
    }

    function currentLocationView() {
        return <Pressable style={[AppStyles.flexRowStart, { marginLeft: 55 + 16, marginTop: 8 }]}
            onPress={() => {
                getCurrentLocation(isUserLogined, showBlockedLocationModal).
                    then((currentLocation: any) => {
                        if (currentLocation) handleSelectedLocationNavigation(currentLocation)
                    })
            }}>
            <IconView icon={'gps.svg'} size={18} />
            <Text style={[TextStyle.text14xb,
            { marginLeft: 8, color: AppTheme.color.primary }]}>
                Use Current Location</Text>

        </Pressable>
    }

    const showBlockedLocationModal = () => {
        // disableScroll.on()
        setBlockedLocationModal(true)
    }

    const closeBlockedLocationModal = () => {
        disableScroll.off()
        setBlockedLocationModal(false)
    }

    useEffect(() => {
        const reduxState = store.getState()
        if (reduxState.previousSelectedLocation) {
            var list: any = reduxState.previousSelectedLocation
            updatePrevSearchResult(list)
            updateSearchResult(list)
        }
    }, [])

    return <View style={{ minHeight: '100vh', height: '100%', backgroundColor: '#F7F7F8' }}>
        <CommonSearchLocalityHeader
            navigation={props.navigation}
            currentLocationView={currentLocationView}
            textInputView={textInputView}
            hideCart={true} />

        <View style={{
            backgroundColor: AppTheme.color.background,
            paddingTop: AppTheme.headerHeight + 45
        }}>

            {
                searchResult && searchResult.length > 0 && searchResult.map((result, index) =>
                    <Pressable onPress={() => { onLocationSelect(result) }}
                        key={index}
                        style={[AppStyles.flexRowSpaceBetween, {
                            paddingHorizontal: 16, paddingVertical: 16,
                            borderColor: '#d3d3d3',
                            borderTopWidth: index == 0 ? 0 : 0.5
                        }]}>
                        <View style={{ marginRight: 36 }}>
                            {AutoColorTypedStringView(index, searchWord, result['mtxt'])}
                            <Text numberOfLines={1} ellipsizeMode="tail" style={[TextStyle.text12, {
                                marginTop: 4, width: AppTheme.appWidth - 90, color: AppTheme.color.grey.text
                            }]}>{result['stxt']}</Text>
                        </View>
                        <IconView icon={'arrow_tilt_45.svg'} size={13} />
                    </Pressable>)
            }
        </View>

        <CommonBottomSheet key={'blocked location'}
            showModal={blockedLocationModal}
            modalData={ModalContent.BlockedLocation}
            closeModal={closeBlockedLocationModal}
            primaryAction={closeBlockedLocationModal} />
    </View>
}

export default SearchLocality;
